import React, { Suspense } from 'react';

import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';

import RecordTransition from '../components/RecordTransition';
import SearchPage from '../components/SearchPage/lazy';

const SearchPageRoute = () => {
	const url = new URL(window.location.href);
	const searchQuery = url.searchParams.get('q') || '';

	return (
		<>
			<RecordTransition name={AnalyticsKeys.PEOPLE_VIEW} />
			<TrackPageLoad name={AnalyticsKeys.PEOPLE_VIEW} />
			<Suspense fallback={null}>
				<SearchPage searchQuery={searchQuery} />
			</Suspense>
		</>
	);
};

export default SearchPageRoute;
